export default {
  fields: {
    country: 'País do banco',
    iban: 'IBAN',
    routing_number: 'Número de routing',
    account_number: 'Número de conta',
    sort_code: 'Sort code',
    account_type: 'Tipo de conta',
  },
  help: {
    country: 'O país do banco, que pode ser diferente do país do restaurante.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code e número de conta',
      description: 'A forma habitual de introduzir uma conta do Reino Unido.',
    },
    iban: {
      title: 'IBAN',
      description: 'O número de conta bancária internacional.',
    },
    us_local: {
      title: 'Número de routing e de conta',
      description: 'Uma conta bancária dos EUA.',
    },
  },
  account_types: {
    checking: 'Conta à ordem',
    savings: 'Conta poupança',
  },
  actions: {
    save: 'Guardar conta bancária',
    cancel: 'Cancelar',
    edit: 'Editar',
  },
  card: {
    account: 'Conta',
    country: 'País',
    status: 'Estado',
  },
  statuses: {
    active: 'Ativa',
    pending_verification: 'Em verificação',
    action_needed: 'Ação necessária',
    errored: 'Falha no pagamento',
    missing: 'Em falta',
  },
  notes: {
    pending_verification:
      'A Adyen verifica todas as contas bancárias antes de os pagamentos começarem. Confirme-a na página da Adyen com um acesso ao banco ou um extrato bancário.',
    action_needed:
      'O fornecedor de pagamentos não conseguiu confirmar esta conta bancária. Verifique os dados ou introduza outra conta.',
    errored:
      'Um pagamento para esta conta falhou e os pagamentos estão suspensos. Verifique os dados ou introduza outra conta.',
  },
};
